
































































































































































































import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import moment from "moment";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Comments, { ResourceType } from "@/store/modules/Comments";
import Viewpoints from "@/store/modules/Viewpoints";
import { Observable, ZenObservable } from "zen-observable-ts";
import { API, graphqlOperation } from "aws-amplify";
import { onCreateThreadComment, onDeleteThreadComment, onUpdateThreadComment } from "@/graphql/subscriptions";
import Colors from "@/utils/Colors";
import Modelling from "@/store/modules/Modelling";
import _ from "lodash";
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { UpdateCommentInput } from "@/API";
import ExportGrowingTable from '@/views/FileExport/ExportGrowingTable.vue';
import ExportFixedTable from '@/views/FileExport/ExportFixedTable.vue';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import TagMenu from "@/components/comments/TagMenu.vue";
import CommentEditor from '@/components/comments/CommentEditor.vue';
import CommentFocusResource from '@/components/comments/CommentFocusResource.vue';

const commentsModule = getModule(Comments)
const choicesModule = getModule(Choices)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const modelling = getModule(Modelling);
const decisionsModule = getModule(Decisions)
const workspaceOptions = getModule(WorkspaceOptions)


@Component({
    components: {
        CardTitle, 
        FactorValueDisplay, 
        ExportGrowingTable, 
        ExportFixedTable, 
        TagMenu, 
        CommentEditor,
        CommentFocusResource
        }
})
export default class CommentThread extends Vue {

    @Prop()
    tagKeyedComments!: Object

    @Prop()
    allTags!: string[]

    @Prop()
    name!: string

    @Prop({required: true})
    decisionId!: string;

    @Prop({required: true})
    showContent!: boolean;

    @Prop({required: true})
    resource!: {
        id: string | 'CONTENT',
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    secondaryResource!: {
        id: string | "WEIGHT",
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    tertiaryResource: {
        id: string,
        name?: string,
        type: ResourceType
    }

    @Prop({default: false, type: Boolean})
    showAllThreads!: boolean

    @Prop({default: false, type: Boolean})
    hover!: boolean

    @Prop()
    commentThread!: string

    @Ref()
    commentEditor!: HTMLDivElement;

    private colors = Colors.COLORS
    private newComment = ""
    private appendingComment = ""
    private editComment = ""
    private isError = false;
    private submittingComment = false;
    private deletingComment = false;
    private showEdit = ""
    private hoverTitle = ""
    private clearInc = 0;
    private selectedTags = [];
    private editTag = ''
    get commentVertical(){
        return workspaceOptions.commentVertical;
    }

    get commentBottomHeight(){
        return workspaceOptions.commentBottomHeight;
    }
    get userProfiles() {
        return usersModule.userProfiles;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    private getUserAvatarName(userId: string) {
        let name = this.getDisplayName(userId);
        if (name) {
            return name;
        }
    }

    private getDate(payload: any) {
        let date = moment(payload).format("LLL");
        if (date) {
            return date;
        }
        return '--';
    }

    private getDisplayName(userId: string) {
        let user: any;
        if (userId === this.userId) {
            return 'You'
            // user = this.currentUser;
        } else {
            user = this.userProfiles[userId]
        }

        if (!user) {
            return null;
        }

        if (!user.first) {
            return user.email.split('@')[0];
        }

        let name = '';
        if (user.first) {
            name = name + user.first;
        }
        if (user.last) {
            name = name + ' ' + user.last;
        }
        return name;
    }

    get userId(): string {
        if (this.currentUser) {
            return this.currentUser.userId;
        }
        return '';
    }

    get filterTags(): string[] {
        if(workspaceOptions.filterTags.length > 0) {
            return this.allTags.filter(tag => workspaceOptions.filterTags.includes(tag));
        } else
            return this.allTags
    }

    get commentKeys() {
        let keys = Object.keys(this.tagKeyedComments)

        keys = keys.sort((a,b)=> {
            if (a === 'Choice') {
                return -1;
            }
             if (b === 'Choice') {
                return 1;
            }
            if(a < b) {
                return -1
            }
            if(a > b) {
                return 1
            }
            if(a === b) {
                return 0
            }

        })
        return keys
    }

    async addComment() {
        if (this.newComment.trim().length == 0) {
            return;
        }

        if(!this.userId) {
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 3000);
            return;
        }

        this.submittingComment = true;
        let result = {
            comment: this.newComment,
            decisionId: this.decisionId,
            resourceId: this.resource.id,
            secondaryResourceId: this.secondaryResource.id,
            tertiaryResourceId: this.tertiaryResource.id,
            threadId: this.commentThread,
            tags: this.selectedTags

        }
        this.$emit("new", result)
        // this.allComments[viewpointId].splice(0, 0, result);
        this.showEdit = ''
        this.selectedTags = []
        this.clearInc += 1;
        this.newComment = '';
        this.submittingComment = false;

    }

    async appendComment(tag) {
        if (this.appendingComment.trim().length == 0) {
            return;
        }

        if(!this.userId) {
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 3000);
            return;
        }

        this.submittingComment = true;
        let result = {
            comment: this.appendingComment,
            decisionId: this.decisionId,
            resourceId: this.resource.id,
            secondaryResourceId: this.secondaryResource.id,
            tertiaryResourceId: this.tertiaryResource.id,
            threadId: this.commentThread,
            tags: [tag]

        }
        this.$emit("new", result)
        // this.allComments[viewpointId].splice(0, 0, result);
        this.showEdit = ''
        this.selectedTags = []
        this.clearInc += 1;
        this.newComment = '';
        this.submittingComment = false;

    }

    async updateComment(comment: any) {
        if (this.editComment.trim().length == 0) {
            return;
        }

        if(!this.userId) {
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 3000);
            return;
        }

        this.submittingComment = true;
        let payload = {
            comment: this.editComment,
            decisionId: this.decisionId,
            id: comment.id,
            threadId: comment.threadId,
            tags: comment.tags
        }

        this.$emit("edit", {comment: payload, resource: this.resource.id})
      
        this.selectedTags = []
        this.clearInc += 1;
        this.editComment = '';
        this.showEdit = '';
        this.submittingComment = false;
        
    }
    async deleteComment(commentId: string) {
        this.deletingComment = true;
        this.$emit('delete', {commentId: commentId, resource: this.resource.id})

        this.deletingComment = false;
    }

    private changeSelectedTags(tags) {
        if(tags === null) {
            this.selectedTags = []
        }
        else
            this.selectedTags = tags
    }

}
